import React, { useState } from "react";
import { MdSearch, MdClear } from "react-icons/md";
import { useTranslation } from "react-i18next";

type SearchBoxProps = {
  placeholder: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onCompositionStart?: (e: React.CompositionEvent<HTMLInputElement>) => void;
  onCompositionEnd?: (e: React.CompositionEvent<HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  onSelect?: (start: number, end: number) => void;
};

const SearchBox: React.FC<SearchBoxProps> = ({
  placeholder,
  value: controlledValue,
  onChange,
  onFocus,
  onBlur,
  onCompositionStart,
  onCompositionEnd,
  inputRef,
  onSelect,
}) => {
  const { t } = useTranslation();
  const [internalValue, setInternalValue] = useState("");
  const value = controlledValue !== undefined ? controlledValue : internalValue;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e);
    } else {
      setInternalValue(e.target.value);
    }
  };

  const handleClear = () => {
    if (onChange) {
      const syntheticEvent = {
        target: { value: "" },
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      onChange(syntheticEvent);
    } else {
      setInternalValue("");
    }
  };

  return (
    // 枠全体を label にして、虫眼鏡や余白をタップしても入力欄にフォーカスするようにする
    <label className="flex items-center bg-Surface border border-MiraiPrimary rounded-2xl pl-4 pr-1 py-1 sm:py-1.5 w-full gap-1 transition-colors focus-within:border-MiraiPrimary focus-within:ring-1 focus-within:ring-MiraiPrimary">
      <MdSearch className="text-TextSecondary text-2xl shrink-0" />
      <input
        type="text"
        className="min-w-0 flex-1 border-none outline-none bg-transparent font-sans text-[16px] sm:text-lg text-TextPrimary placeholder-TextSecondary"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onCompositionStart={onCompositionStart}
        onCompositionEnd={onCompositionEnd}
        ref={inputRef}
        onSelect={(e) => {
          const target = e.currentTarget;
          onSelect?.(target.selectionStart ?? 0, target.selectionEnd ?? 0);
        }}
      />
      <button
        // スマホは html の font-size が小さいため px 指定
        className={`h-[44px] w-[44px] shrink-0 rounded-xl bg-transparent border-none cursor-pointer p-0 flex items-center justify-center text-2xl text-TextSecondary transition-[opacity,background-color] hover:text-TextPrimary active:bg-Background ${
          value ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={handleClear}
        disabled={!value}
        type="button"
        aria-label={t("入力を消去")}
      >
        <MdClear />
      </button>
    </label>
  );
};

export default SearchBox;
